// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as CatalogPriceLookUpInput from "./CatalogPriceLookUpInput.res.js";

function get(values, field) {
  switch (field) {
    case "Name" :
      return values.name;
    case "CapacityUnit" :
      return values.capacityUnit;
    case "CapacityValue" :
      return values.capacityValue;
    case "CapacityPrecision" :
      return values.capacityPrecision;
    case "Ean13" :
      return values.ean13;
    case "StockKeepingUnit" :
      return values.stockKeepingUnit;
    case "StockKeepingUnitIsDuplicate" :
      return values.stockKeepingUnitIsDuplicate;
    case "PriceLookUpCode" :
      return values.priceLookUpCode;
    case "InternalCode" :
      return values.internalCode;
    case "AlcoholVolume" :
      return values.alcoholVolume;
    case "Year" :
      return values.year;
    case "Bulk" :
      return values.bulk;
    case "PurchasePrice" :
      return values.purchasePrice;
    case "SupplierId" :
      return values.supplierId;
    case "VariantPrices" :
      return values.variantPrices;
    case "InitialStockQuantity" :
      return values.initialStockQuantity;
    case "InitialStockComment" :
      return values.initialStockComment;
    case "MaxStockThreshold" :
      return values.maxStockThreshold;
    case "MinStockThreshold" :
      return values.minStockThreshold;
    case "StockOrderTriggerThreshold" :
      return values.stockOrderTriggerThreshold;
  }
}

function set(values, field, value) {
  switch (field) {
    case "Name" :
      let newrecord = {...values};
      newrecord.name = value;
      return newrecord;
    case "CapacityUnit" :
      let newrecord$1 = {...values};
      newrecord$1.capacityUnit = value;
      return newrecord$1;
    case "CapacityValue" :
      let newrecord$2 = {...values};
      newrecord$2.capacityValue = value;
      return newrecord$2;
    case "CapacityPrecision" :
      let newrecord$3 = {...values};
      newrecord$3.capacityPrecision = value;
      return newrecord$3;
    case "Ean13" :
      let newrecord$4 = {...values};
      newrecord$4.ean13 = value;
      return newrecord$4;
    case "StockKeepingUnit" :
      let newrecord$5 = {...values};
      newrecord$5.stockKeepingUnit = value;
      return newrecord$5;
    case "StockKeepingUnitIsDuplicate" :
      let newrecord$6 = {...values};
      newrecord$6.stockKeepingUnitIsDuplicate = value;
      return newrecord$6;
    case "PriceLookUpCode" :
      let newrecord$7 = {...values};
      newrecord$7.priceLookUpCode = value;
      return newrecord$7;
    case "InternalCode" :
      let newrecord$8 = {...values};
      newrecord$8.internalCode = value;
      return newrecord$8;
    case "AlcoholVolume" :
      let newrecord$9 = {...values};
      newrecord$9.alcoholVolume = value;
      return newrecord$9;
    case "Year" :
      let newrecord$10 = {...values};
      newrecord$10.year = value;
      return newrecord$10;
    case "Bulk" :
      let newrecord$11 = {...values};
      newrecord$11.bulk = value;
      return newrecord$11;
    case "PurchasePrice" :
      let newrecord$12 = {...values};
      newrecord$12.purchasePrice = value;
      return newrecord$12;
    case "SupplierId" :
      let newrecord$13 = {...values};
      newrecord$13.supplierId = value;
      return newrecord$13;
    case "VariantPrices" :
      let newrecord$14 = {...values};
      newrecord$14.variantPrices = value;
      return newrecord$14;
    case "InitialStockQuantity" :
      let newrecord$15 = {...values};
      newrecord$15.initialStockQuantity = value;
      return newrecord$15;
    case "InitialStockComment" :
      let newrecord$16 = {...values};
      newrecord$16.initialStockComment = value;
      return newrecord$16;
    case "MaxStockThreshold" :
      let newrecord$17 = {...values};
      newrecord$17.maxStockThreshold = value;
      return newrecord$17;
    case "MinStockThreshold" :
      let newrecord$18 = {...values};
      newrecord$18.minStockThreshold = value;
      return newrecord$18;
    case "StockOrderTriggerThreshold" :
      let newrecord$19 = {...values};
      newrecord$19.stockOrderTriggerThreshold = value;
      return newrecord$19;
  }
}

let Lenses = {
  get: get,
  set: set
};

let Lenses$1 = {
  Lenses: Lenses,
  get: get,
  set: set
};

let include = Form.Make({
  get: get,
  set: set
});

function validateMinStockThreshold(state) {
  let maxStockThreshold = state.maxStockThreshold;
  let minStockThreshold = state.minStockThreshold;
  if (minStockThreshold === undefined) {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
  let trigger = state.stockOrderTriggerThreshold;
  if (trigger !== undefined && minStockThreshold > trigger) {
    return {
      TAG: "Error",
      _0: I18n.t("The minimum stock should be less or equal to the value triggering a new order.")
    };
  }
  if (maxStockThreshold !== undefined && state.minStockThreshold >= maxStockThreshold) {
    return {
      TAG: "Error",
      _0: I18n.t("The minimum stock should be less than the maximum stock.")
    };
  } else {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
}

function validateStockOrderTriggerThreshold(state) {
  let maxStockThreshold = state.maxStockThreshold;
  if (maxStockThreshold === undefined) {
    if (state.stockOrderTriggerThreshold !== undefined) {
      return {
        TAG: "Error",
        _0: I18n.t("You have to define the maximum stock beforehand.")
      };
    } else {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
  }
  let trigger = state.stockOrderTriggerThreshold;
  if (trigger !== undefined && trigger >= maxStockThreshold) {
    return {
      TAG: "Error",
      _0: I18n.t("This value should be less than maximum stock value.")
    };
  } else {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
}

function validatePriceLookupCode(state) {
  let match = state.priceLookUpCode;
  let value = match.value;
  if (value === undefined) {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
  if (value > CatalogPriceLookUpInput.pluRange[1]) {
    return {
      TAG: "Error",
      _0: I18n.t("The PLU code must be between 1 and 9997.")
    };
  }
  if (!match.invalidValues.some(plu => plu === value)) {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
  let match$1 = CatalogPriceLookUpInput.makeValue(state.priceLookUpCode.invalidValues, undefined, undefined);
  if (match$1.TAG === "Ok") {
    return {
      TAG: "Error",
      _0: I18n.t("This PLU code is used by another product.")
    };
  } else {
    return {
      TAG: "Error",
      _0: I18n.t("There is no more PLU code available.")
    };
  }
}

let schema = [
  {
    TAG: "StringNotEmpty",
    _0: "Name"
  },
  {
    TAG: "Custom",
    _0: "MinStockThreshold",
    _1: validateMinStockThreshold
  },
  {
    TAG: "Custom",
    _0: "StockOrderTriggerThreshold",
    _1: validateStockOrderTriggerThreshold
  },
  {
    TAG: "Custom",
    _0: "PriceLookUpCode",
    _1: validatePriceLookupCode
  },
  {
    TAG: "Custom",
    _0: "StockKeepingUnit",
    _1: param => {
      if (param.stockKeepingUnitIsDuplicate) {
        return {
          TAG: "Error",
          _0: ""
        };
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  }
];

let Core = include.Core;

let Schema = include.Schema;

let FormLegacyProvider = include.FormLegacyProvider;

let FormProvider = include.FormProvider;

let InputText = include.InputText;

let InputSuggestionComboBox = include.InputSuggestionComboBox;

let InputSelect = include.InputSelect;

let InputToggleButtonGroup = include.InputToggleButtonGroup;

let InputCountrySelect = include.InputCountrySelect;

let InputTextArea = include.InputTextArea;

let InputPassword = include.InputPassword;

let InputNumber = include.InputNumber;

let InputOptionalNumber = include.InputOptionalNumber;

let InputRadioGroup = include.InputRadioGroup;

let InputRadioCardGroup = include.InputRadioCardGroup;

let InputPhone = include.InputPhone;

let InputCheckbox = include.InputCheckbox;

let InputToggleSwitch = include.InputToggleSwitch;

let InputDate = include.InputDate;

let InputOptionalDate = include.InputOptionalDate;

let InputOptionalDateFastNav = include.InputOptionalDateFastNav;

let InputDateRange = include.InputDateRange;

let CancelButton = include.CancelButton;

let SubmitButton = include.SubmitButton;

let ControlEnterKey = include.ControlEnterKey;

let AutoSave = include.AutoSave;

let useFormPropState = include.useFormPropState;

let useField = include.useField;

let useFormState = include.useFormState;

let useFormDispatch = include.useFormDispatch;

let validate = include.validate;

let isValidField = include.isValidField;

export {
  Lenses$1 as Lenses,
  Core,
  Schema,
  FormLegacyProvider,
  FormProvider,
  InputText,
  InputSuggestionComboBox,
  InputSelect,
  InputToggleButtonGroup,
  InputCountrySelect,
  InputTextArea,
  InputPassword,
  InputNumber,
  InputOptionalNumber,
  InputRadioGroup,
  InputRadioCardGroup,
  InputPhone,
  InputCheckbox,
  InputToggleSwitch,
  InputDate,
  InputOptionalDate,
  InputOptionalDateFastNav,
  InputDateRange,
  CancelButton,
  SubmitButton,
  ControlEnterKey,
  AutoSave,
  useFormPropState,
  useField,
  useFormState,
  useFormDispatch,
  validate,
  isValidField,
  validateMinStockThreshold,
  validateStockOrderTriggerThreshold,
  validatePriceLookupCode,
  schema,
}
/* include Not a pure module */
